import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http'
import 'rxjs/add/operator/toPromise'
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'


import { SeguridadService } from '../_services/seguridad.service'

import { AppSettings } from '../_models/settings.models'

@Injectable()

export class CuestionarioService{

  constructor(private http: Http,
              private seguridad: SeguridadService
            ){

  }

  getListaCuestionarios(id_modulo:number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_modulo: id_modulo, tokenid: userToken, action: "ListagetCuestionarioModulo", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  nuevoCuestionario(id_modulo:number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_modulo: id_modulo, tokenid: userToken, action: "CuestionarioCreateCuestionario", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  borrarCuestionario(id_cuestionario:number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_cuestionario: id_cuestionario, tokenid: userToken, action: "CuestionarioDeleteCuestionario", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getCuestionario(id_cuestionario:number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_cuestionario: id_cuestionario, tokenid: userToken, action: "CuestionariogetCuestionario", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }


  getLastCuestionario(){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ tokenid: userToken, action: "GetLastCuestionario", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getFullCuestionario(id_cuestionario:number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_cuestionario: id_cuestionario, tokenid: userToken, action: "CuestionarioGetPreguntasFullPath", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getEvidenciasSinRelacionar(id_cuestionario:number){


  }

  getListaEvidencias(id_cuestionario:number){



    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_cuestionario: id_cuestionario, tokenid: userToken, action: "CuestionariogetEvidencias", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {



            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getListaEvidenciasCuestionario(id_cuestionario:number){


    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_cuestionario: id_cuestionario, nivelmodulo: "0", tokenid: userToken, action: "CuestionarioEvidenciasSinRelacionar", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }


  getListaEvidenciasModulo(id_cuestionario:number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_cuestionario: id_cuestionario, tokenid: userToken, action: "CuestionariogetEvidenciasModulo", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getCuestionarioListaEvidenciasFijas(id_cuestionario:number){
    
    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_cuestionario: id_cuestionario, tokenid: userToken, action: "CuestionariogetEvidenciasFijasModulo", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getListaEvidenciasFijas(id_cuestionario:number){
    
    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_cuestionario: id_cuestionario, tokenid: userToken, action: "CuestionariogetEvidenciasFijas", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }


  getEvidenciaInfo(id_evidencia:number){
    
    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_evidencia: id_evidencia, tokenid: userToken, action: "CuestionarioEvidenciaInfo", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }


  getCuestionarioTipos(){
    
    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ tokenid: userToken, action: "GetCuestionarioTipo", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  setEvidenciasFijas(id_cuestionario:number, id_evidencia:number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_cuestionario: id_cuestionario,id_evidencia: id_evidencia, tokenid: userToken, action: "CuestionarioSetEvidenciasFijas", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  deleteEvidenciasFijas(id_cuestionario:number, id_evidencia:number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_cuestionario: id_cuestionario,id_evidencia: id_evidencia, tokenid: userToken, action: "CuestionarioDeleteEvidenciasFijas", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  checkInicioCuestionarioEvidenciasFijas(id_cuestionario:number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_cuestionario: id_cuestionario, tokenid: userToken, action: "CheckInicioCuestionarioEvidenciasFijas", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getListaPreguntas(id_cuestionario:number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_cuestionario: id_cuestionario, tokenid: userToken, action: "CuestionariogetPreguntas", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  setPreguntaAsoc(id_pregunta:number, id_respuesta: number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_pregunta: id_pregunta, id_respuesta: id_respuesta, tokenid: userToken, action: "CuestionariosetPreguntaAsoc", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  deletePreguntaAsoc(id_respuesta: number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_respuesta: id_respuesta, tokenid: userToken, action: "CuestionarioDeletePreguntaAsoc", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  setEvidencias(envio: any){

    let userToken : string = localStorage.getItem('currentUserToken');


    envio.tokenid = userToken;
    envio.action = "CuestionariosetEvidencia";
    envio.api_keytoken = AppSettings.API_KEYTOKEN;

    return this.http.post(AppSettings.API_URL, JSON.stringify(envio))
        .map((response2: Response) => {

            if (!this.seguridad.getError(response2)){ //si no hay error

              return response2;

            }

        });
  }

  setRespuesta(respuesta: any){

    let userToken : string = localStorage.getItem('currentUserToken');


    respuesta.tokenid = userToken;
    respuesta.action = "CuestionariosetRespuesta";
    respuesta.api_keytoken = AppSettings.API_KEYTOKEN;

    console.log(respuesta);

    return this.http.post(AppSettings.API_URL, JSON.stringify(respuesta))
        .map((response2: Response) => {

            if (!this.seguridad.getError(response2)){ //si no hay error

              return response2;

            }

        });
  }

  setPregunta(pregunta: any){

    let userToken : string = localStorage.getItem('currentUserToken');


    pregunta.tokenid = userToken;
    pregunta.action = "CuestionariosetPregunta";
    pregunta.api_keytoken = AppSettings.API_KEYTOKEN;

    console.log(pregunta);

    return this.http.post(AppSettings.API_URL, JSON.stringify(pregunta))
        .map((response2: Response) => {

            if (!this.seguridad.getError(response2)){ //si no hay error

              return response2;

            }

        });
  }

  deleteRespuesta(respuesta: any){

    let userToken : string = localStorage.getItem('currentUserToken');


    respuesta.tokenid = userToken;
    respuesta.action = "CuestionarioDeleteRespuesta";
    respuesta.api_keytoken = AppSettings.API_KEYTOKEN;

    console.log(respuesta);

    return this.http.post(AppSettings.API_URL, JSON.stringify(respuesta))
        .map((response2: Response) => {

            if (!this.seguridad.getError(response2)){ //si no hay error

              return response2;

            }

        });
  }

  deletePregunta(pregunta: any){

    let userToken : string = localStorage.getItem('currentUserToken');


    pregunta.tokenid = userToken;
    pregunta.action = "CuestionarioDeletePregunta";
    pregunta.api_keytoken = AppSettings.API_KEYTOKEN;

    console.log(pregunta);

    return this.http.post(AppSettings.API_URL, JSON.stringify(pregunta))
        .map((response2: Response) => {

            if (!this.seguridad.getError(response2)){ //si no hay error

              return response2;

            }

        });
  }

  deleteDocumento(id_pregunta: number, id_cuestionario: number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_pregunta: id_pregunta, id_cuestionario: id_cuestionario, tokenid: userToken, action: "CuestionarioUnsetPreguntaDocumento", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response2: Response) => {

            if (!this.seguridad.getError(response2)){ //si no hay error

              return response2;

            }

        });
  }

  setCuestionarioNombre(cuestionario: any){

    let userToken : string = localStorage.getItem('currentUserToken');

    cuestionario.tokenid = userToken;
    cuestionario.action = "CuestionarioSetNombre";
    cuestionario.api_keytoken = AppSettings.API_KEYTOKEN;

    return this.http.post(AppSettings.API_URL, JSON.stringify(cuestionario))
        .map((response2: Response) => {

            if (!this.seguridad.getError(response2)){ //si no hay error

              return response2;

            }

        });
  }


  setCuestionarioOrden(id_cuestionario: any, datos:any){

    let userToken : string = localStorage.getItem('currentUserToken');

//    console.log(JSON.stringify(datos));

  return this.http.post(AppSettings.API_URL, JSON.stringify({id_cuestionario: id_cuestionario, tokenid: userToken, jsonDatos: JSON.stringify(datos), action: "CuestionariosetOrden", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response2: Response) => {

            if (!this.seguridad.getError(response2)){ //si no hay error

              return response2;

            }

        });
  }


  setCuestionarioRespuestaOrden(id_cuestionario: any, datos:any){

    let userToken : string = localStorage.getItem('currentUserToken');

//    console.log(JSON.stringify(datos));

  return this.http.post(AppSettings.API_URL, JSON.stringify({id_cuestionario: id_cuestionario, tokenid: userToken, jsonDatos: JSON.stringify(datos), action: "CuestionariosetRespuestaOrden", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response2: Response) => {

            if (!this.seguridad.getError(response2)){ //si no hay error

              return response2;

            }

        });
  }

  setCuestionarioOrdenInicial(id_cuestionario: any, datos:any){

    let userToken : string = localStorage.getItem('currentUserToken');

  
//   console.log(JSON.stringify(datos));

  return this.http.post(AppSettings.API_URL, JSON.stringify({id_cuestionario: id_cuestionario, tokenid: userToken, jsonDatos: JSON.stringify(datos), action: "CuestionariosetOrdenInicial", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response2: Response) => {

            if (!this.seguridad.getError(response2)){ //si no hay error

              return response2;

            }

        });
  }

  CuestionarioMoverPreguntaInicial(id_cuestionario: any, datos:any){

    let userToken : string = localStorage.getItem('currentUserToken');


 //   console.log(JSON.stringify(datos));

  return this.http.post(AppSettings.API_URL, JSON.stringify({id_cuestionario: id_cuestionario, tokenid: userToken, jsonDatos: JSON.stringify(datos), action: "CuestionarioMoverPreguntaInicial", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response2: Response) => {

            if (!this.seguridad.getError(response2)){ //si no hay error

              return response2;

            }

        });
  }


  CuestionarioMoverPreguntaInicialToSecundaria(id_cuestionario: any, id_respuesta:any,id_pregunta:any){

    let userToken : string = localStorage.getItem('currentUserToken');

  return this.http.post(AppSettings.API_URL, JSON.stringify({id_cuestionario: id_cuestionario, tokenid: userToken, id_respuesta:id_respuesta,id_pregunta:id_pregunta, action: "CuestionarioMoverPreguntaInicialToSecundaria", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response2: Response) => {

            if (!this.seguridad.getError(response2)){ //si no hay error

              return response2;

            }

        });
  }


  duplicarCuestionario(id_cuestionario: number){

    let userToken : string = localStorage.getItem('currentUserToken');
    
    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_cuestionario: id_cuestionario, tokenid: userToken, action: "CuestionarioDuplicarCuestionario", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response2: Response) => {

            if (!this.seguridad.getError(response2)){ //si no hay error

              return response2;

            }

        });
  }

}



// WEBPACK FOOTER //
// ./src/app/_services/cuestionario.service.ts